import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import $ from 'jquery';
import { hideDashboardChartTooltips } from './utils/chartTooltips';

class ChartTooltipRouteCleanup extends Component {
    componentDidMount() {
        this.unlisten = this.props.history.listen(() => {
            hideDashboardChartTooltips();
        });
        $(document).on('click.chartTooltipCleanup', '.left_sidebar a, .navbar a, .mobile_header a', () => {
            hideDashboardChartTooltips();
        });
    }

    componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
        }
        $(document).off('click.chartTooltipCleanup');
        hideDashboardChartTooltips();
    }

    render() {
        return null;
    }
}

export default withRouter(ChartTooltipRouteCleanup);
